import CheckRound from '@ori-ui/icons/lib/CheckRound';
import ClockOutlined from '@ori-ui/icons/lib/ClockOutlined';
import InfoOutlined from '@ori-ui/icons/lib/InfoOutlined';
import RoundExclam from '@ori-ui/icons/lib/RoundExclam';
import { jsx as _jsx } from "react/jsx-runtime";
const MuiAlert = {
  variant: 'filled',
  iconMapping: {
    error: /*#__PURE__*/_jsx(RoundExclam, {}),
    info: /*#__PURE__*/_jsx(InfoOutlined, {}),
    success: /*#__PURE__*/_jsx(CheckRound, {}),
    warning: /*#__PURE__*/_jsx(ClockOutlined, {})
  }
};
export default MuiAlert;